export enum PatientPresenceType {
  NEAR_THE_DEVICE = 'Near the device',
  OUT_OF_RANGE = 'Out of range',
  PRIVACY_ON = 'Privacy on',
  UNAVAILABLE = 'Unavailable'
}

export const getPatientPresence = (patientPresence: string | undefined, deviceStatus: string | undefined): PatientPresenceType => {
  if (deviceStatus?.toUpperCase() === 'OFFLINE') {
    return PatientPresenceType.UNAVAILABLE;
  }

  const presence = patientPresence?.toUpperCase();
  if (presence === 'NEAR') {
    return PatientPresenceType.NEAR_THE_DEVICE;
  } else if (presence === 'OUT_OF_RANGE') {
    return PatientPresenceType.OUT_OF_RANGE;
  } else if (presence === 'PRIVACY_ON') {
    return PatientPresenceType.PRIVACY_ON;
  } else if (presence === 'UNKNOWN') {
    return PatientPresenceType.UNAVAILABLE;
  } else {
    return PatientPresenceType.OUT_OF_RANGE;
  }
};
